import RegionPicker from './region-picker.vue'
export type { RegionPickerProps } from './props'
export default RegionPicker